import { BlockType } from '@/lib/types';
import SectionBlock from './blocks/section-block';
import TextBlock from './blocks/text-block';
import DateBlock from './blocks/date-block';
import SelectionBlock from './blocks/selection-block';
import LinkBlock from './blocks/link-block';
import SectionTitleBlock from './blocks/section-title-block';
import LongTextBlock from './blocks/long-text-block';

interface Props {
  block: {
    type: number;
    label: string;
    options: Map<string, string>;
  };
  content: any;
  subContents?: any;
  isPublic?: boolean;
}

export default function BlockContentType({ block, content, subContents, isPublic = false }: Props) {
  switch (block.type) {
    case BlockType.Section:
      return (
        <SectionBlock
          block={block}
          content={content}
          subContents={subContents}
          isPublic={isPublic}
        />
      );
    case BlockType.Selection:
      return <SelectionBlock block={block} content={content} />;
    case BlockType.Date:
      return <DateBlock block={block} content={content} />;
    case BlockType.Link:
      return <LinkBlock block={block} content={content} />;
    case BlockType.SectionTitle:
      return <SectionTitleBlock block={block} />;
    case BlockType.LongText:
      return <LongTextBlock block={block} content={content} />;
    default:
      return <TextBlock block={block} content={content} />;
  }
}
